import reducerGenerator from 'reducerGenerator';
import types from '../constants/qmyxTypes';
import * as utils from 'public/js/utils/base';

const { localStorage } = window;

const lastCity = localStorage.getItem(`__last_city__${utils.getToken()}`);

// 登录用户信息、城市信息
const initialState = {
    user: {},
    cityMap: {},
    locCity: {},
    globalConfig: {
        is_fan: 1,
        nav_list: [],
        style: 'default',
        token_name: ''
    },
    currentCity: lastCity ? JSON.parse(lastCity) : {},
    isLogined: false,
    mobileDistricts: [],
    mobileDistrictMap: {},
};

const ACTION_HANDLERS = {
    [types.SET_USER_INFO](state, action) {
        // 用于天眼内判断是否是当天注册用户
        localStorage.setItem(
            `__last_tel__${utils.getToken()}`,
            action.userInfo.broker_tel
        );
        return {
            ...state,
            user: action.userInfo
        };
    },
    [types.SET_CITY](state, action) {
        return {
            ...state,
            cityMap: action.city
        };
    },
    [types.SET_LOC_CITY](state, action) {
        return {
            ...state,
            locCity: action.locCity
        };
    },
    [types.SET_CURRENT_CITY](state, action) {
        localStorage.setItem(
            `__last_city__${utils.getToken()}`,
            JSON.stringify(action.currentCity)
        );
        return {
            ...state,
            currentCity: action.currentCity
        };
    },
    [types.SET_GLOBAL_CONFIG](state, action) {
        localStorage.setItem(
            `__last_style__${utils.getToken()}`,
            action.globalConfig.style
        );
        return {
            ...state,
            globalConfig: {
                ...state.globalConfig,
                ...action.globalConfig
            }
        };
    },
    [types.SET_LOGINED](state, action) {
        return {
            ...state,
            isLogined: action.isLogined
        };
    },
    [types.SET_MOBILE_DISTRICT](state, action) {
        return {
            ...state,
            mobileDistricts: action.mobileDistricts,
            mobileDistrictMap: action.mobileDistrictMap,
        };
    }
};

export default reducerGenerator(initialState, ACTION_HANDLERS);



// WEBPACK FOOTER //
// ./src/rootRedux/reducers/qmyxUserInfo.js